import { useEffect } from 'react';

/**
 * Custom hook to dynamically update the theme-color meta tag
 * @param {string} color - Hex color code (e.g., '#047857', '#1e40af')
 */
const useThemeColor = (color) => {
  useEffect(() => {
    // Update theme-color meta tag
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', color);
    }

    // Update Apple status bar color
    const metaAppleStatusBar = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
    if (metaAppleStatusBar) {
      // Use 'black-translucent' for dark colors, 'default' for light colors
      const isDark = isColorDark(color);
      metaAppleStatusBar.setAttribute('content', isDark ? 'black-translucent' : 'default');
    }

    // Cleanup: Reset to default color when component unmounts
    return () => {
      if (metaThemeColor) {
        metaThemeColor.setAttribute('content', '#047857'); // Default emerald color
      }
    };
  }, [color]);
};

/**
 * Helper function to determine if a color is dark
 * @param {string} hexColor - Hex color code
 * @returns {boolean} - True if color is dark
 */
const isColorDark = (hexColor) => {
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  return luminance < 0.5;
};

export default useThemeColor;
